/**
 * @param {string} [text] - the text show inside the avatar (if image found, then will show image instead of text)
 * @param {image} [image] - to show the image as avatar
 * @param {string} [color] - background color of the avatar
 * @param {number} [size] - the size of the avatar in px
 * @param {StyleSheet} [style] - additional style
 * @param {StyleSheet} [imageStyle] - additional image style
 * @param {StyleSheet} [textStyle] - additional text style
 * @returns {React.ReactNode}
 */
import React from 'react';
import { View, Image, Text } from 'react-native';
import { theme } from '../styles';

type Props = {
  text?: string;
  image?: string;
  color?: string;
  size?: number;
  style?: any;
  imageStyle?: any;
  textStyle?: any;
};

export const Avatar = ({ text, image, color = theme.colors.red, size = 26, style, imageStyle, textStyle }: Props) => {
  const containerStyle = {
    backgroundColor: color,
    width: size,
    height: size,
    borderRadius: size / 2,
    justifyContent: 'center',
    alignItems: 'center',
    ...style,
  };

  const imageContainerStyle = {
    borderRadius: size / 2,
    overflow: 'hidden',
    ...imageStyle,
  };

  const textStyleObj = {
    color: '#ffffff',
    fontWeight: 'normal',
    fontSize: size / 2.1,
    textAlign: 'center',
    marginTop: -1,
    ...textStyle,
  };

  return (
    <View style={containerStyle}>
      {image ? (
        <View style={imageContainerStyle}>
          <Image source={{ uri: image }} style={{ width: size, height: size }} />
        </View>
      ) : (
        <Text style={textStyleObj}>{text?.toUpperCase().substring(0, 2)}</Text>
      )}
    </View>
  );
};
